/**
 * Loan installment math aligned with PayrollEngineService (first-period estimate).
 */

export function calculateMonthlyInstallment({
  principal = 0,
  annualInterestRatePct = 0,
  repaymentMonths = 0,
  paymentMethod = "straight_line",
  openingBalance = null,
} = {}) {
  const p = Number(principal) || 0;
  const months = Math.max(0, Math.floor(Number(repaymentMonths) || 0));
  const ratePct = Math.max(0, Number(annualInterestRatePct) || 0);
  const opening = openingBalance == null ? p : Number(openingBalance) || 0;
  const method =
    paymentMethod === "reducing_balance" ? "reducing_balance" : "straight_line";

  if (p <= 0 || months <= 0) {
    return 0;
  }

  const annualRate = ratePct / 100;
  const monthlyRate = annualRate / 12;

  if (method === "straight_line") {
    const totalInterest = p * annualRate * (months / 12);
    return roundMoney((p + totalInterest) / months);
  }

  const principalPart = p / months;
  const interestPart = opening * monthlyRate;
  return roundMoney(principalPart + interestPart);
}

export function roundMoney(value) {
  return Math.round(Math.max(Number(value) || 0, 0) * 100) / 100;
}

export function formatLoanMoney(amount, currency = "KES") {
  return `${currency} ${Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
